module.exports = __webpack_public_path__ + "static/media/expense-limits.4fcf7abf.svg";